import {combineReducers} from "@reduxjs/toolkit";
import search from "features/pages/threads/search/reducer";
import favorite from "./favorite/reducer";
import archive from "features/pages/threads/archive/reducer";
import highlight from "features/pages/threads/highlights/reducer";
import single from "./single/reducer";
import upsert from "./upsert/reducer";
import like from "./like/reducer";
import delete_reducer from "./delete/reducer";
import archive_action from "features/modals/thread-archive/reducer";
import leaderboards from "features/pages/threads/leaderboards/reducer";
import favorites from "features/pages/threads/favorite/reducer";

export default combineReducers({
    search,
    archive,
    favorite,
    highlight,
    single,
    upsert,
    like,
    delete: delete_reducer,
    archive_action,
    leaderboards,
    favorites
})